import { render, staticRenderFns } from "./provisionsAdmin.vue?vue&type=template&id=3f8d4ef1"
import script from "./provisionsAdmin.vue?vue&type=script&lang=js"
export * from "./provisionsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports